module.exports = __webpack_public_path__ + "static/media/CloseXGrey.21b0e777.svg";